import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/kardex-sbc-empleado';

/**
 * GET Kardex SBC Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getKardexSbcEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Kardex SBC Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getKardexSbcEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Kardex SBC Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postKardexSbcEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Kardex SBC Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchKardexSbcEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Kardex SBC Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteKardexSbcEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Kardex SBC Empleado
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarKardexSbcEmpleado = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, {
      estados_globales: ESTATUS_AUTORIZADO,
    });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Kardex SBC Empleados (Vista Optimizada sin paginar, con Plaza/Puesto/
 * Área/Bimestre/Periodo Fiscal ya resueltos en el propio query)
 * @param {object} params - p. ej. { empleado_id }
 * @param {object} [options]
 * @param {boolean} [options.silent403] - no mostrar el aviso de "sin permiso" si la
 *   respuesta es 403 (uso: precarga en segundo plano de una pestaña secundaria, donde
 *   el usuario no pidió explícitamente este dato -- otros errores sí se siguen avisando).
 * @returns {Promise<object[]>}
 */
export const getKardexSbcEmpleadosVistaOptimized = async (params, options = {}) => {
  try {
    const response = await API.get('nominas/kardex-sbc-empleado-vista-optimized', { params });
    return response.data;
  } catch (err) {
    if (!(options.silent403 && err?.response?.status === 403)) onError(err);
  }
  return [];
};
